module.exports = __webpack_public_path__ + "img/crown.ee0f79a7.svg";